/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {GenericObject} from '@ion/core/src/types/entities';
import {
  Page
} from '@/types/pages';
import {
  SecondaryNav,
  SideSheet
} from '@/types/sidesheet';
import {NavReducerState} from '../types';

// input selectors ...
const selectIsSideSheetArrowVisible = ({nav}: NavReducerState) => nav.isSideSheetArrowVisible;
export const selectPages            = ({nav}: NavReducerState) => nav.pages;
const selectSelectedIndex           = ({nav}: NavReducerState) => nav.selectedIndex;
const selectActiveIndex             = ({nav}: NavReducerState) => nav.activeIndex;
const selectCurrentPage             = ({nav}: NavReducerState) => nav.currentPage;
const selectSecondaryNav            = ({nav}: NavReducerState) => nav.secondaryNav;
const selectIgnoreQuery             = ({nav}: NavReducerState) => nav.ignoreQuery;
const selectIsUserProfileView       = ({nav}: NavReducerState) => nav.isUserProfileView;
const selectNavCollapsedStatus      = ({nav}: NavReducerState) => nav.collapsed;
const selectSideSheet               = ({nav: {sideSheet}}: NavReducerState) => sideSheet;
const selectDeepLinkRestricted      = ({nav: {deepLinkRestricted}}: NavReducerState) => deepLinkRestricted;
const selectlayoutOffsetHeight      = ({nav: {layoutOffsetHeight}}: NavReducerState) => layoutOffsetHeight;
const selectMobileListVisible       = ({nav}: NavReducerState) => nav.mobileListVisible;

export const selectMobileSideSheetOpen = (
  {nav: {sideSheet: {mobileSideSheetOpen}}}: NavReducerState
) => mobileSideSheetOpen;
export const selectDesktopSideSheetOpen = (
  {nav: {sideSheet: {desktopSideSheetOpen}}}: NavReducerState
) => desktopSideSheetOpen;
const selectGridOptions = ({nav}: NavReducerState) => nav.gridOptions;

// output selectors ...
export const gridOptionsSelector = createDeepEqualSelector(selectGridOptions,
  (gridOptions: GenericObject): GenericObject => gridOptions
);

export const isSideSheetArrowVisibleSelector = createSelector(selectIsSideSheetArrowVisible,
  (isSideSheetArrowVisible: boolean): boolean => isSideSheetArrowVisible
);

export const mobileListVisibleSelector = createSelector(selectMobileListVisible,
  (mobileListVisible: boolean): boolean => mobileListVisible
);

export const pagesSelector = createSelector(selectPages,
  (pages: Page[]): Page[] => pages
);

export const selectedIndexSelector = createSelector(selectSelectedIndex,
  (selectedIndex: number): number => selectedIndex
);

export const activeIndexSelector = createSelector(selectActiveIndex,
  (activeIndex: number): number => activeIndex
);

export const currentPageSelector = createSelector(selectCurrentPage,
  (currentPage: string): string => currentPage
);

export const secondaryNavSelector = createDeepEqualSelector(selectSecondaryNav,
  (secondaryNav: SecondaryNav): SecondaryNav => secondaryNav
);

export const ignoreQuerySelector = createSelector(selectIgnoreQuery,
  (ignoreQuery: boolean): boolean => ignoreQuery
);

export const sideSheetSelector = createDeepEqualSelector(selectSideSheet,
  (sideSheet: SideSheet): SideSheet => sideSheet
);

export const mobileSideSheetOpenSelector = createSelector(selectMobileSideSheetOpen,
  (mobileSideSheetOpen: boolean): boolean => mobileSideSheetOpen
);

export const desktopSideSheetOpenSelector = createSelector(selectDesktopSideSheetOpen,
  (desktopSideSheetOpen: boolean): boolean => desktopSideSheetOpen
);

export const isUserProfileViewSelector = createSelector(selectIsUserProfileView,
  (isUserProfileView: boolean): boolean => isUserProfileView
);

export const deepLinkRestrictedSelector = createSelector(selectDeepLinkRestricted,
  (deepLinkRestricted: boolean): boolean => deepLinkRestricted
);

export const layoutOffsetHeightSelector = createSelector(selectlayoutOffsetHeight,
  (layoutOffsetHeight: number): number => layoutOffsetHeight
);

export const navCollapsedStatusSelector = createSelector(selectNavCollapsedStatus,
  (collapsed: boolean): boolean => collapsed
);
